import React from "react";
import './index.css';
import ReactDOM from "react-dom/client"; // Note la différence d'import
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { BrowserRouter } from 'react-router-dom';
import { PaginationProvider } from "./context/PaginationContext";
import { LoadingProvider } from "./context/LoadingContext";
import { SortProvider } from "./context/SortContext";
import { HeaderProvider } from "./context/HeaderContext";
import { FooterProvider } from "./context/FooterContext";
import { UserProvider } from "./context/userContext";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { fr } from 'date-fns/locale/fr';
import { msalInstance } from "./services/api/msalInstance";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <MsalProvider instance={msalInstance}>
    <UserProvider>
      <LoadingProvider>
        <HeaderProvider>
          <FooterProvider>
            <SortProvider>
              <PaginationProvider>
                <BrowserRouter
                  future={{
                    v7_relativeSplatPath: true,
                    v7_startTransition: true,
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                    <App />
                  </LocalizationProvider>
                </BrowserRouter>
              </PaginationProvider>
            </SortProvider>
          </FooterProvider>
        </HeaderProvider>
      </LoadingProvider>
    </UserProvider>
  </MsalProvider>,
);
